import React from 'react';
import {
  TextField,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { Clear as ClearIcon } from '@mui/icons-material';

interface SearchTextFieldProps {
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClear: () => void;
  placeholder?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  sx?: React.CSSProperties | any;
}

const SearchTextField: React.FC<SearchTextFieldProps> = ({
  label,
  value,
  onChange,
  onClear,
  placeholder = '',
  fullWidth = true,
  disabled = false,
  sx,
}) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      // フォームの親要素に送信を任せる
    }
  };

  return (
    <TextField
      fullWidth={fullWidth}
      variant="outlined"
      size="small"
      label={label}
      value={value}
      onChange={onChange}
      onKeyDown={handleKeyDown}
      placeholder={placeholder}
      disabled={disabled}
      sx={sx}
      InputProps={{
        endAdornment: value && (
          <InputAdornment position="end">
            <IconButton
              aria-label={`clear ${label}`}
              onClick={onClear}
              edge="end"
              size="small"
              disabled={disabled}
            >
              <ClearIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchTextField;